import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { GET_COLLECTION_YARD_URL } from "../middleware/routes";
import { ICollectionYard, ICollectionYardApi, ICollectionYardState } from "../types/collectionYard";
import { Status } from "../types/state";
import { axiosRequestApi } from "../utils/axiosRequest";

const initCollectionYardStateCollectionYard = {
  name: "",
  address: "",
  wasteTypeIds: [],
  wasteTypeRates: {},
  paidBeforeVisitRequired: false,
  paidVisitVerification: true,
};

export const initCollectionYardState: ICollectionYardState = {
  status: Status.idle,
  errorMsg: null,
  collectionYard: structuredClone(initCollectionYardStateCollectionYard),
};

export const collectionYardSlice = createSlice({
  name: "collectionYard",
  initialState: initCollectionYardState,
  reducers: {
    cleanUpCollectionYard: (state) => {
      state.collectionYard = structuredClone(initCollectionYardStateCollectionYard);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCollectionYardThunk.pending, (state) => {
        state.status = Status.requesting;
      })
      .addCase(getCollectionYardThunk.fulfilled, (state, action) => {
        state.status = Status.success;
        state.errorMsg = null;

        state.collectionYard = action.payload;
      })
      .addCase(getCollectionYardThunk.rejected, (state) => {
        state.status = Status.error;
      });
  },
});

export const getCollectionYardThunk = createAsyncThunk<ICollectionYard>("user/getCollectionYardThunk", async () => {
  const response = await axiosRequestApi.get(GET_COLLECTION_YARD_URL);

  const data = response.data as ICollectionYardApi;

  const collectionYard: ICollectionYard = {
    name: data.name,
    address: data.address,
    wasteTypeIds: data.CollectionYardWasteTypes.map((item: any) => item.waste_type_id),
    wasteTypeRates: data.CollectionYardWasteTypes.reduce((acc: Record<number, number>, item: any) => {
      acc[item.waste_type_id] = item.rate ?? 0;
      return acc;
    }, {}),
    paidBeforeVisitRequired: data.paid_before_visit_required,
    paidVisitVerification: data?.paid_visit_verification,
  };

  return collectionYard;
});

export const { cleanUpCollectionYard } = collectionYardSlice.actions;

export const collectionYardReducer = collectionYardSlice.reducer;
